import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionConfirmationData } from '../types';

type Props = {
  data: ActionConfirmationData;
};

const ActionConfirmationWidget: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const impact = data.balanceImpact;

  const statusLabels: Record<ActionConfirmationData['status'], string> = {
    pending: t('aiChat.widgets.actionConfirmation.pending'),
    confirmed: t('aiChat.widgets.actionConfirmation.confirmed'),
    cancelled: t('aiChat.widgets.actionConfirmation.cancelled'),
  };
  return (
    <div className="ai-chat-widget ai-chat-widget-action-confirm">
      <div className="ai-chat-widget-action-confirm-header">
        <span className="ai-chat-widget-action-confirm-title">
          {data.actionType}
        </span>
        <span
          className={`ai-chat-widget-action-confirm-badge ai-chat-widget-action-confirm-badge-${data.status}`}>
          {statusLabels[data.status]}
        </span>
      </div>
      {data.details.map((detail, idx) => (
        <div key={idx} className="ai-chat-widget-action-confirm-row">
          <span className="ai-chat-widget-action-confirm-label">
            {detail.label}
          </span>
          <span className="ai-chat-widget-action-confirm-value">
            {detail.value}
          </span>
        </div>
      ))}
      {impact && (
        <div className="ai-chat-widget-action-confirm-impact">
          <div className="ai-chat-widget-action-confirm-impact-title">
            {t('aiChat.widgets.actionConfirmation.balanceImpact')} &mdash;{' '}
            {impact.categoryName}
          </div>
          <div className="ai-chat-widget-action-confirm-impact-row">
            <span>{t('aiChat.widgets.actionConfirmation.currentBalance')}</span>
            <span>
              {impact.currentBalance} {impact.unit}
            </span>
          </div>
          <div className="ai-chat-widget-action-confirm-impact-row">
            <span>{t('aiChat.widgets.actionConfirmation.thisRequest')}</span>
            <span>
              &minus;{impact.requestedDays} {impact.unit}
            </span>
          </div>
          <div
            className={`ai-chat-widget-action-confirm-impact-row remaining${
              impact.remainingAfter < 0 ? ' warning' : ''
            }`}>
            <span>{t('aiChat.widgets.actionConfirmation.remainingAfter')}</span>
            <span>
              {impact.remainingAfter} {impact.unit}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionConfirmationWidget;
